import React from 'react';
import { BackLink } from '../components/BackLink';
import { PersonalizationChat } from '../components/application/PersonalizationChat';
export const PersonalizationPage = () => {
  return <div className="w-full min-h-screen bg-[#1A1A1D] flex overflow-hidden" data-id="element-1113">
      <div className="flex-1 flex flex-col h-screen overflow-hidden" data-id="element-1114">
        <div className="flex-1 overflow-y-auto bg-[#1A1A1D]" data-id="element-1115">
          <div className="max-w-3xl mx-auto p-6" data-id="element-1116">
          <BackLink to="/app" className="mb-4" data-id="element-1117">
            Back to Dashboard
          </BackLink>
            <PersonalizationChat data-id="element-1118" />
          </div>
        </div>
      </div>
    </div>;
};